import React from "react";
import "./AdminDashboardPage.module.css"
import AdminDashboard from "../../components/PageComponents/AdminDashboard/AdminDashboard"

const AdminDashboardPage = () => {
    return (
        <>
            <div className="admin-dashboard-page">
                <AdminDashboard />
            </div>
        </>
    )
}

export default AdminDashboardPage